import { ReactElement, RefObject } from "react";

import { Checkbox } from "@newsela/angelou";
import ReactDOM from "react-dom";

import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";

import { IInstructionalFeatureOption } from "@/search/NewSearchPageMVP/FilterPanel/filters/InstructionalFeature/InstructionalFeature.constants";
import { useSearchAdminPermissions } from "@/search/NewSearchPageMVP/provider/hooks";
import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";
import { IContentValues } from "@/search/NewSearchPageMVP/types/IContentValues";
import { checkboxCss } from "./InstructionalFeatureCheckbox.styles";

const CheckboxWithTrackEvent = withTrackEvent(Checkbox);

export const InstructionalFeatureCheckbox = ({
  paramName,
  currentRef,
  isDomReady,
  IconComponent,
  option,
  targetElement,
}: IInstructionalFeatureCheckbox) => {
  const {
    handlers: { hasSearchParamValue, toggleSearchParamValue },
  } = useSearchPageContext();

  const { blockActionAndShowConfirmationModal, blockFilterChanges } =
    useSearchAdminPermissions();

  const onChange = (option: IContentValues) => {
    if (blockFilterChanges) {
      blockActionAndShowConfirmationModal();
      return;
    }

    toggleSearchParamValue(paramName, option.value);
  };

  const eventTrackingDescription = `Toggle ${hasSearchParamValue(paramName, option.value) ? "off" : "on"} the ${option.label} instructional feature filter in search`;

  return (
    <>
      <CheckboxWithTrackEvent
        __cssFor={checkboxCss}
        checked={hasSearchParamValue(paramName, option.value)}
        label={option.label}
        onChange={() => onChange(option)}
        value={option.value}
        inputRef={currentRef}
        dataProps={{
          "data-qa-selector": `search-instructional-filter-${option.label}`,
        }}
        actionName={actionNames.filter}
        objectType={objectTypes.content}
        streamProperties={{
          description: eventTrackingDescription,
        }}
      />
      {isDomReady && ReactDOM.createPortal(IconComponent, targetElement)}
    </>
  );
};

interface IInstructionalFeatureCheckbox {
  paramName: string;
  currentRef: RefObject<HTMLInputElement>;
  isDomReady: boolean;
  IconComponent: ReactElement;
  option: IInstructionalFeatureOption;
  targetElement: Element;
}
